<template>
    <div class="ui-datepicker-range form-row">
        <div class="col">
            <v-date-picker
                v-model="start"
                :min-date="minDate"
                :max-date="end"
                :masks="masks"
                :attributes="attributes"
                is-required
                locale="pt-BR"
                mode="date"
                title-position="left"
                transition="fade"
                @input="startHandler">
                <template #default="{ inputValue, inputEvents }">
                    <label class="ui-input ui-input-group" :class="size">
                        <span v-if="labelStart" class="label">
                            <span v-html="labelStart" />
                        </span>
                        <input :data-ui="dataUiStart" v-mask="'##/##/####'" :value="inputValue" type="tel" class="input" v-on="inputEvents" />
                        <span class="group">
                            <i class="far fa-calendar-alt"/>
                        </span>
                    </label>
                </template>
            </v-date-picker>
        </div>

        <div class="col">
            <v-date-picker
                v-model="end"
                :min-date="start"
                :masks="masks"
                :attributes="attributes"
                is-required
                locale="pt-BR"
                mode="date"
                title-position="left"
                transition="fade"
                @input="endHandler">
                <template #default="{ inputValue, inputEvents }">
                    <label class="ui-input ui-input-group" :class="size">
                        <span v-if="labelEnd" class="label">
                            <span v-html="labelEnd" />
                        </span>
                        <input :data-ui="dataUiEnd" v-mask="'##/##/####'" :value="inputValue" type="tel" class="input" v-on="inputEvents" />
                        <span class="group">
                            <i class="far fa-calendar-alt" />
                        </span>
                    </label>
                </template>
            </v-date-picker>
        </div>
    </div>
</template>

<script>
    import vDatePicker from 'v-calendar/lib/components/date-picker.umd'
import { data } from 'vue-popperjs'
    import { mask } from 'vue-the-mask'
    const moment = require('moment')
    require('moment/locale/pt-br')
    
    export default {
        name: 'ui-datepicker-range',

        components: {
            vDatePicker,
        },

        directives: {
            mask,
        },

        props: {
            value: {
                required: true,
                type: Object,
                default () {
                    return {}
                }
            },
            labelStart: {
                required: false,
                type: String,
                default: ''
            },
            labelEnd: {
                required: false,
                type: String,
                default: ''
            },
            dateStart: {
                required: false,
                type: String,
                default: null
            },
            /**
             * Utilize para alterar o tamanho do input
             */
            size: {
                type: String,
                required: false,
                default: 'md'
            },
            dataUiStart: {
                type: String,
                required: false,
                default: ''
            },
            dataUiEnd: {
                type: String,
                required: false,
                default: ''
            },
        },

        data() {
            return {
                masks: {
                    input: 'DD/MM/YYYY',
                },
                start: '',
                end: ''
            }
        },

        computed: {
            attributes: {
                cache: false,
                get() {
                    return [{
                        highlight: {
                            base: {
                                fillMode: 'light'
                            },
                        },
                        dates: {
                            start: this.start,
                            end: this.end,
                        },
                    }]
                }
            },
            /**
             * Computed property que define a data mínima para seleção, de acordo com a data de início
             */
            minDate() {
                return this.start && moment(this.start).isBefore(new Date()) ? this.start : new Date()
            },
        },

        watch: {
            /**
             * Observer para a prop value de modo a identificar quando as datas de início e fim
             * devem ser atualizadas
             */
            value() {
                this.setValue()
            }
        },

        mounted() {
            this.setValue()
        },

        methods: {
            /**
             * Atualiza as datas de início e fim de acordo com a prop value
             */
            setValue() {
                // Utiliza-se a função toDate pois o v-calendar obriga as datas a serem do tipo Date
                this.start = this.value && this.value.start
                    ? moment(this.value.start, "YYYY-MM-DD").toDate()
                    : moment().toDate()
                this.end = this.value && this.value.end
                    ? moment(this.value.end, "YYYY-MM-DD").toDate()
                    : moment(this.start).add(2, 'days').toDate()
            },
            /**
             * Event handler que trata o evento de quando a data inicial do intervalo é setada
             */
            startHandler(event) {
                this.$emit('input', {
                    start: moment(event).format("YYYY-MM-DD"),
                    end: moment(this.end).format("YYYY-MM-DD")
                })
            },
            /**
             * Event handler que trata o evento de quando a data final do intervalo é setada
             */
            endHandler(event) {
                this.$emit('input', {
                    start: moment(this.start).format("YYYY-MM-DD"),
                    end: moment(event).format("YYYY-MM-DD")
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>